import { render, staticRenderFns } from "./AddTerminate.vue?vue&type=template&id=1ca486c8&scoped=true"
import script from "./AddTerminate.vue?vue&type=script&lang=js"
export * from "./AddTerminate.vue?vue&type=script&lang=js"
import style0 from "./AddTerminate.vue?vue&type=style&index=0&id=1ca486c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca486c8",
  null
  
)

export default component.exports